

























import LetterEditor from '@/components/letters/Editor.vue'

import Vue from 'vue'
export default Vue.extend({
  components: {
    LetterEditor,
  },
  props: {
    code: {
      type: String,
      required: true,
    },
    complete: {
      type: Function,
      required: true,
    },
  },
  methods: {
    confirm(): boolean {
      return window.confirm(
        (this.$t('letters.confirmSend') as string) || 'Sure? No changes afterwards!'
      )
    },
    publish(copy: any) {
      copy.published_at = new Date()
      return copy
    },
  },
})
